import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import _ from "lodash";
import { showNotification } from "Common/utils/Notification";
import ReactSelect from "../ReactSelect/ReactSelect2";
import booleanType from "../../../constants/booleanType.json";
import Button from "../ButtonComponent/Button";
import CookieSegmentCard from "../EditableViews/CookieSegmentCard";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";

const CookiesSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  segmentType,
  toggleVisiblity,
  versionData,
  segmentId,
}) => {
  const [buttons, setButtons] = useState<any>([]);
  const [selectType, setSelectType] = useState<any>([]);
  const [errors, setErrors] = useState<any>({
    buttons: buttons?.map(() => ({ label: "", value: "" })),
  });
  const [isLoading, setIsLoading] = useState<any>(false);

  useEffect(() => {
    if (data && data?.list?.[0]?.value) {
      const boolType = [];
      setButtons(data?.list);
      data?.list?.forEach((item) => {
        // Update column one content
        if (item?.value === booleanType[1].value) {
          boolType.push(booleanType[1]);
        } else if (item?.value === booleanType[2].value) {
          boolType.push(booleanType[2]);
        }
      });

      setSelectType(boolType);
    }
  }, [data]);

  const addButton = () => {
    setSelectType([...selectType, { label: "", value: "" }]);
    setButtons([...buttons, { label: "", value: "" }]);
    let newErrors = { ...errors };
    newErrors?.buttons?.push({ label: "", value: "" });
    setErrors(newErrors);
  };

  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedSegments = selectType.filter((_, i) => i !== index);
    setSelectType(updatedSegments);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };

  const handleButtonValueChange = (
    index: number,
    contentType: any,
    value: any
  ) => {
    const updatedButtons = buttons.map((button: any, i: number) => {
      if (i === index) {
        button.value = value.value;
      }
      return button;
    });
    setButtons(updatedButtons);
  };

  const handleInputChange = (index, field, value) => {
    const update = selectType.map((item, i) => {
      if (i === index) {
        if (field === "value") {
          item.label = value.label;
          item.value = value.value;
        }
      }
      return item;
    });
    setSelectType(update);
    const updatedButtons = buttons.map((button, i) => {
      if (i === index) {
        if (field === "value") {
          console.log("here");
          button[field] = value.value;
        } else {
          button[field] = value;
        }
      }
      return button;
    });

    setButtons(updatedButtons);

    const updatedErrors = { ...errors };
    if (updatedErrors.buttons[index]) {
      updatedErrors.buttons[index][field] = "";
    }
    setErrors(updatedErrors);
  };

  const handleSave = async (pageId, id) => {
    const newErrors = {
      buttons: buttons?.map(() => ({ label: "", value: "" })),
    };

    buttons.forEach((button, index) => {
      if (!button.label.trim()) {
        newErrors.buttons[index].label = "label is required .";
      }
      if (!button.value.trim()) {
        newErrors.buttons[index].value = "value is required .";
      }
    });

    setErrors(newErrors);

    if (newErrors?.buttons?.every((error) => !error.label && !error.value)) {
      const payload = {
        segment_type: "cookies_segments",
        list: buttons,
      };
      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Cookies added successfully!", "success");
        }
      } catch (e) {
        showNotification(
          "An error occurred while adding the banner. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          {/* Add Button */}
          <div className="flex justify-end my-4">
            <button
              onClick={addButton}
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Add Cookies
            </button>
          </div>
          {versionData?.list?.length > 0 ? (
            <div className="grid grid-cols-1 gap-4 mb-2 xl:grid-cols-12">
              Old Data
            </div>
          ) : null}
          <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
            {/* Render Buttons */}
            {versionData?.list?.map((button, index) => (
              <div key={index} className="py-4 xl:col-span-4">
                <CookieSegmentCard
                  buttonData={button}
                  index={index}
                  handleButtonValueChange={handleButtonValueChange}
                  handleInputChange={handleInputChange}
                  errors={errors}
                  removeButton={removeButton}
                  isEditable={false}
                  selectType={selectType}
                />
              </div>
            ))}
          </div>
          {buttons?.length > 0 ? (
            <div className="grid grid-cols-1 gap-4 mb-2 xl:grid-cols-12">
              New Data
            </div>
          ) : null}

          <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
            {/* Render Buttons */}
            {buttons?.map((button, index) => (
              <div key={index} className="py-4 xl:col-span-4">
                <CookieSegmentCard
                  buttonData={button}
                  index={index}
                  handleButtonValueChange={handleButtonValueChange}
                  handleInputChange={handleInputChange}
                  errors={errors}
                  removeButton={removeButton}
                  isEditable={true}
                  selectType={selectType}
                />
              </div>
            ))}
          </div>

          {/* Save Button */}
          <div className="flex justify-end gap-2 mt-4">
            <Button
              isLoading={isLoading}
              handleSave={handleSave}
              pageId={pageId}
              id={segmentId}
            />

            <button
              className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
              onClick={() => handleDelete(segmentId, data?.segment_type)}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiesSegment;
